// ===== DATA LAYER =====
//
// Fetches approved submissions from the PHP backend. If the API is
// unreachable or returns something unexpected (typical when running the
// Vite dev server without a database), it transparently falls back to the
// bundled mock data so the gallery is always demonstrable.

import { mockSubmissions } from './mock-data.js';

// Optionally override the API origin with a `VITE_API_BASE` env var
// (e.g. VITE_API_BASE=http://raikancinta-vgb-gallery.test). Defaults to a
// same-origin relative request.
const API_BASE = import.meta.env.VITE_API_BASE ?? '';

/**
 * Fetch approved submissions for a wedding.
 * @param {number|string} weddingId
 * @returns {Promise<Array>} Array of submission objects
 */
export async function fetchSubmissions(weddingId) {
    const url = `${API_BASE}/api/submissions.php?weddingId=${encodeURIComponent(weddingId)}`;

    try {
        const response = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(`API returned HTTP ${response.status}`);

        const data = await response.json();
        if (!Array.isArray(data)) throw new Error('API response was not an array');

        return data;
    } catch (error) {
        console.warn(
            `[gallery] Live API unavailable (${error.message}). ` +
            'Falling back to bundled mock data.'
        );
        return mockSubmissions;
    }
}
